import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  const { t } = useLanguage();
  const whatsappNumber = '351911739498';
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label={t(translations.whatsapp.tooltip)}
    >
      <div className="relative">
        {/* Pulse animation */}
        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-25" />
        
        {/* Main button */}
        <div className="relative flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 hover:scale-110 hover:shadow-xl">
          <MessageCircle className="w-7 h-7 text-white" />
        </div>

        {/* Tooltip */}
        <div className="absolute bottom-full right-0 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
          <div className="bg-slate-800 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap shadow-lg">
            {t(translations.whatsapp.tooltip)}
            <div className="absolute top-full right-4 -mt-1 border-4 border-transparent border-t-slate-800" />
          </div>
        </div>
      </div>
    </a>
  );
};
